import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';

const ANY_STATUS = 'ANY';

interface NotificationSourceFilterProps {
    onChange: (value?: string) => void;
    value?: string;
}
export const NotificationSourceFilter: React.FC<NotificationSourceFilterProps> = ({ value, onChange }) => {
    const { settings } = useSelector((state: ApplicationState) => state.settings);
    const handleStateChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.value === ANY_STATUS) {
                onChange(undefined);
            } else {
                onChange(e.target.value);
            }
        },
        [onChange]
    );
    const renderOption = React.useCallback(
        ([value, label]) => (
            <MenuItem key={value} value={value}>
                {label}
            </MenuItem>
        ),
        []
    );
    return (
        <Select value={value ?? ANY_STATUS} onChange={handleStateChange} variant="outlined" size="small">
            {Object.entries({
                [ANY_STATUS]: 'All Sources',
                API: 'ASAP',
                ...(!!settings?.scheduledNotificationsEnabled && { SCHEDULED_TASK: 'Scheduled' }),
                ...(!!settings?.triggeredNotificationsEnabled && { RULE: 'Triggered' })
            }).map(renderOption)}
        </Select>
    );
};
